module.exports = __webpack_public_path__ + "static/media/c6bannerModulF_small.0b5e3221.jpg";